/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */

// AUTOGENERATED BY glean_parser v19.1.0. DO NOT EDIT. DO NOT COMMIT.

import EventMetricType from '@mozilla/glean/private/metrics/event';

/**
 * Passkey sign-in completed end-to-end on the frontend. Fires after the
 * WebAuthn ceremony succeeds AND any subsequent Sync password step
 * (creating a new password or entering an existing one) completes. Does
 * not fire if the user abandons during a password step. Distinct from
 * the per-surface `*_passkey_submit_success` events, which fire at
 * ceremony-verified time and don't reflect the full journey outcome.
 *
 * Generated from `passkey.auth_success`.
 */
export const authSuccess = new EventMetricType<{
  reason?: string;
}>(
  {
    category: 'passkey',
    name: 'auth_success',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  ['reason']
);
